import React from 'react';

import Modal from "react-bootstrap/Modal";
import { Image } from 'react-bootstrap';

import LoginLogo from "./LoginLogo.svg";

import "./LoginModal.scss";


const LoginModal = (props) => {
    const { children } = props;
    return (
        <Modal show={true} contentClassName="modal-styles" className="login-modal" onHide={()=>{}}>
            <Modal.Body>
                <Image className="login-logo" src={LoginLogo} />
                {children}
            </Modal.Body>
        </Modal>
    );
}

export default LoginModal;